export const themeHelper = {
  data: function () {
    return {
      images: undefined,
      defaultImages: undefined
    }
  },
  props: {
    theme: {
      default: "Default"
    }
  },
  methods: {
    getImage: function (imageKey) {
      if (this.images === undefined) {
        this.images = require("../../../Themes/" + this.theme + "/images.json")
      }
      if(!this.images[imageKey]){
        this.defaultImages = require("../../../Themes/Default/images.json")
        return this.defaultImages[imageKey];
      }
      return this.images[imageKey]
    }
  }
}
